<div class="flex-1 flex flex-col gap-12 pb-10">
  <!-- 1. Cards de status -->
  <l-dashboard-metrics-grid
    [highlight]="dashboardData.highlight"
    [metrics]="dashboardData.topMetrics"
  />

  <!-- 2. Engajamento -->
  <section class="p-6 bg-lGray950 light:bg-lGray900 rounded-3xl border border-lGray800">
    <l-dashboard-section-header
      title="Engajamento"
      subtitle="Mede o nível de participação dos usuários na plataforma, como acessos, tempo de uso e interações com os cursos."
    />

    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mb-4">
      @for (metric of engagementDonuts; track metric.title) {
        <l-dashboard-donut-metric-card
          [metric]="metric"
          layout="engagement"
          chartSize="large"
        />
      }
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
      @for (metric of engagementProgress; track metric.title) {
        <l-dashboard-progress-metric [metric]="metric" layout="engagement" />
      }
    </div>
  </section>

  <!-- 3. Aprendizado e progresso -->
  <section class="p-6 bg-lGray950 light:bg-lGray900 rounded-3xl border border-lGray800">
    <l-dashboard-section-header
      title="Aprendizado e progresso"
      subtitle="Acompanha o progresso dos usuários nos cursos."
    />

    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 items-stretch">
      <l-dashboard-donut-metric-card
        [metric]="dashboardData.learning.completionRate"
        layout="engagement"
      />

      <l-dashboard-progress-metric
        [metric]="dashboardData.learning.averageProgress"
        layout="engagement"
      />

      <l-dashboard-time-metric-card [metric]="dashboardData.learning.averageCompletionTime" />
    </div>
  </section>

  <!-- 4. Efetividade -->
  <section class="p-6 bg-lGray950 light:bg-lGray900 rounded-3xl border border-lGray800">
    <l-dashboard-section-header
      title="Efetividade"
      subtitle="Avalia o impacto do aprendizado e resultados alcançados."
    />

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <l-dashboard-gauge-chart [metric]="dashboardData.effectiveness.averageGrade" />
      <l-dashboard-counter-metric-card [metric]="dashboardData.effectiveness.certificatesIssued" />
    </div>
  </section>

  <!-- 5. Aulas mais assistidas do ano -->
  <section class="p-6 bg-lGray950 light:bg-lGray900 rounded-3xl border border-lGray800">
    <l-dashboard-ranking-list
      variant="lessons"
      title="Aulas mais assistidas do ano"
      subtitle="Top 5 aulas do último ano"
      nameColumnLabel="Aula"
      valueColumnLabel="Quantidade de visualizações"
      [showProgressBars]="false"
      [items]="mostWatchedLessons"
      [periodOptions]="periodOptions"
      [selectedPeriod]="lessonsPeriod"
      (selectedPeriodChange)="onLessonsPeriodChange($event)"
    />
  </section>

  <!-- 6 e 7. Cursos mais acessados | Cursos com maior taxa de conclusão -->
  <div class="grid grid-cols-1 xl:grid-cols-2 gap-5">
    <section class="p-6 bg-lGray950 light:bg-lGray900 rounded-3xl border border-lGray800 h-full">
      <l-dashboard-ranking-list
        title="Cursos mais acessados"
        subtitle="Ranking dos cursos com maior volume de acessos."
        valueColumnLabel="Quantidade de visualizações"
        [items]="mostAccessedCourses"
        [periodOptions]="periodOptions"
        [selectedPeriod]="coursesAccessPeriod"
        (selectedPeriodChange)="onCoursesAccessPeriodChange($event)"
      />
    </section>

    <section class="p-6 bg-lGray950 light:bg-lGray900 rounded-3xl border border-lGray800 h-full">
      <l-dashboard-ranking-list
        title="Cursos com maior taxa de conclusão"
        subtitle="Ranking dos cursos com melhor desempenho de conclusão."
        valueColumnLabel="Porcentagem de conclusão"
        [items]="highestCompletionCourses"
        [periodOptions]="periodOptions"
        [selectedPeriod]="coursesCompletionPeriod"
        (selectedPeriodChange)="onCoursesCompletionPeriodChange($event)"
      />
    </section>
  </div>
</div>
